import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Link } from '../Link/Link';
import styles from './BypassBlock.module.less';

/**
 * `BypassBlock` implements the [bypass block](https://www.w3.org/WAI/WCAG21/Understanding/bypass-blocks.html)
 * pattern to provide direct access to the primary content of a web page for users who navigate
 * sequentially through content using a keyboard or a similar device.
 *
 * It becomes visible when it receives focus and skips to a particular location in the page
 * (usually the primary content) when activated.
 */
export var BypassBlock = function BypassBlock(_ref) {
  var className = _ref.className,
      dangerouslyForceVisible = _ref.dangerouslyForceVisible,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Skip to content' : _ref$label,
      _ref$targetId = _ref.targetId,
      targetId = _ref$targetId === void 0 ? 'main' : _ref$targetId;
  useDeprecatedClassNameStylePropsWarning('BypassBlock', {
    className: className
  });
  return /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.container, className, _defineProperty({}, styles.forceVisible, dangerouslyForceVisible))
  }, /*#__PURE__*/React.createElement(Link, {
    href: "#".concat(targetId),
    bold: true
  }, label));
};
BypassBlock.displayName = 'BypassBlock';